import {
  EpisodeModel,
  SeasonModel,
  SeriesModel
} from '@modules/entertainment/models/series.model';
import axiosInstance from '../axios-instance';
import { ApiResponse } from '@shared/models/api.model';

export const getSeries = async (
  params?: any
): Promise<ApiResponse<SeriesModel>> => {
  const response = await axiosInstance.get('/media/series/getter', { params });
  return response.data;
};

export const createSeries = async (
  body?: any
): Promise<ApiResponse<SeriesModel>> => {
  return await axiosInstance.post(`/media/series`, body);
};

export const editSeriesRow = async (
  body: any,
  id: string
): Promise<ApiResponse<SeriesModel>> => {
  return await axiosInstance.put(`/media/series/${id}`, body);
};

export const deleteSerie = async (id: string): Promise<void> => {
  return await axiosInstance.delete(`/media/series/${id}`);
};

export const deleteSeriesMany = async (id: string[]): Promise<void> => {
  const data = { ids: id };
  await axiosInstance.delete(`/media/series/many`, { data });
};

export const getSeasons = async (id?: string): Promise<void[]> => {
  const response = await axiosInstance.get(`/media/seasons/series/${id}`);
  return response.data || [];
};

export const createSeason = async (body?: any): Promise<SeasonModel> => {
  return await axiosInstance.post(`/media/seasons`, body);
};

export const editSeason = async (
  body: any,
  id: string
): Promise<SeasonModel> => {
  return await axiosInstance.put(`/media/seasons/${id}`, body);
};

export const deleteSeason = async (id: string): Promise<void> => {
  return await axiosInstance.delete(`/media/seasons/${id}`);
};

export const getEpisodes = async (params: {
  filters: { season: string[] };
  page: number;
  limit: number;
  sort: any;
}): Promise<ApiResponse<any>> => {
  const seasonId = params.filters.season[0];

  const searchParams = new URLSearchParams();
  searchParams.append('query[filter][season]', seasonId);
  searchParams.append('query[page]', String(params.page));
  searchParams.append('query[limit]', String(params.limit));
  searchParams.append('query[sort]', String(params.sort));

  const response = await axiosInstance.get(
    `/media/episodes/getter?${searchParams.toString()}`
  );
  return response.data;
};

export const createEpisode = async (
  body?: any
): Promise<ApiResponse<EpisodeModel>> => {
  return await axiosInstance.post(`/media/episodes`, body);
};

export const editEpisodeRow = async (
  body: any,
  id: string
): Promise<ApiResponse<EpisodeModel>> => {
  return await axiosInstance.put(`/media/episodes/${id}`, body);
};

export const deleteEpisode = async (id: string): Promise<void> => {
  return await axiosInstance.delete(`/media/episodes/${id}`);
};

export const deleteEpisodeMany = async (id: string[]): Promise<void> => {
  const data = { ids: id };
  await axiosInstance.delete(`/media/episodes/many`, { data });
};
